import { calculateLiaCompleteness } from 'config/api/lia/lia.helpers';
import { mapLiaToUpdateInput } from 'config/api/lia/lia.parsers';
import type { Lia, LiaSafeguardCode, UpdateLiaInput } from 'config/api/lia/lia.types';

export type PurposeLiaFormValues = UpdateLiaInput;

export type PurposeLiaValidationMessages = {
  required: string;
  vulnerableComment: string;
};

export const mapLiaToFormValues = (lia: Lia): PurposeLiaFormValues => mapLiaToUpdateInput(lia);

export const mapFormValuesToUpdateInput = (values: PurposeLiaFormValues): UpdateLiaInput => values;

export const buildCompletenessItems = (values: PurposeLiaFormValues) => calculateLiaCompleteness(values);

export const validatePurposeLiaForm = (
  values: PurposeLiaFormValues,
  messages: PurposeLiaValidationMessages,
): Partial<Record<string, string>> => {
  const errors: Partial<Record<string, string>> = {};

  if (values.vulnerableDataSubjectsInvolved && !values.vulnerableDataSubjectsComment.trim()) {
    errors.vulnerableDataSubjectsComment = messages.vulnerableComment;
  }

  if (!values.responsibleMembershipId) {
    errors.responsibleMembershipId = messages.required;
  }

  if (!values.assessmentDate.trim()) {
    errors.assessmentDate = messages.required;
  }

  if (!values.conclusion) {
    errors.conclusion = messages.required;
  }

  return errors;
};

export const toggleSafeguard = (selected: LiaSafeguardCode[], code: LiaSafeguardCode): LiaSafeguardCode[] =>
  selected.includes(code) ? selected.filter(item => item !== code) : [...selected, code];

export const isLiaReadOnly = (lia: Lia): boolean => lia.isDeleted;
